import React from "react";
import { motion } from "framer-motion";
import {
  Gem,
  GraduationCap,
  Landmark,
  BookOpen,
  CalendarDays,
  Scale,
  Ship,
  Building2,
} from "lucide-react";

const sectors = [
  { icon: Gem, label: "Jewellery", note: "Heritage & luxury houses" },
  { icon: GraduationCap, label: "Colleges", note: "Admissions & brand" },
  { icon: Landmark, label: "Banks", note: "Trust & reputation" },
  { icon: BookOpen, label: "Coaching", note: "Enrolment & authority" },
  { icon: Building2, label: "Institutions", note: "Policy & profile" },
  { icon: CalendarDays, label: "Corporate Events", note: "End-to-end production" },
  { icon: Scale, label: "Dispute Resolution", note: "Reputation under fire" },
  { icon: Ship, label: "Intl. Logistics", note: "New vertical · 2026" },
];

const Sectors = () => {
  return (
    <section
      id="sectors"
      data-testid="sectors-section"
      className="section-gutter py-20 md:py-28 border-t border-black/10 bg-[#f6f6f4]"
    >
      <div className="grid grid-cols-12 gap-6 mb-10 md:mb-14">
        <div className="col-span-12 md:col-span-7">
          <div className="overline text-black/60">Chapter 02½ — Sectors</div>
          <h2 className="font-serif-display text-5xl md:text-6xl mt-6 leading-[0.95]">
            Eight sectors. <em>One standard.</em>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
          <p className="text-sm md:text-base text-black/70 leading-relaxed">
            From jewellery vaults to classroom pipelines to shipping lanes —
            where reputation decides outcome, we lead the brief.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 border-l border-t border-black/15">
        {sectors.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.04 * i }}
              className="p-6 md:p-8 border-r border-b border-black/15 bg-white hover:bg-[#0a0a0a] hover:text-white transition-colors group"
              data-testid={`sector-${i}`}
            >
              <Icon size={22} className="opacity-70" />
              <div className="mt-6 font-serif-display text-2xl md:text-3xl leading-tight">
                {s.label}
              </div>
              <div className="mt-3 text-[0.65rem] md:text-[0.7rem] uppercase tracking-[0.2em] text-black/55 group-hover:text-white/60">
                {s.note}
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};

export default Sectors;
